import Icon from '@/components/Icon';
import PermissionRequiredBanner from '@/components/PermissionRequiredBanner';

/** Real implementation lands in Phase 5 (QuickBooks CSV, monthly PDF, savings). */
export default function ExportsPage() {
  return (
    <>
      <PermissionRequiredBanner
        permission="exports.generate"
        message="Exports and financial reports are available to managers and owners. Ask your clinic admin if you need access."
      />
      <div className="p-6 text-center text-slate-500">
        <Icon name="export" className="w-10 h-10 mx-auto mb-3 text-slate-300" />
        <h1 className="text-base font-semibold text-slate-700">Exports</h1>
        <p className="text-xs mt-1">QuickBooks CSV + monthly report land in Phase 5.</p>
      </div>
    </>
  );
}
